import * as React from 'react';
import { PageProps } from 'gatsby';
import classNames from 'classnames';
import Menu from '@/components/menu/menu';
import { useStyles } from '@/hooks/useStyles';

const Header: React.FC<PageProps> = ({ location }) => {
  const { joinClasses } = useStyles();

  const desktopClasses = {
    container: classNames('lg:wrapper lg:!px-[2.5rem]'),
    logo: classNames('md:w-[308px] md:bg-left-center')
  };
  const mobileClasses = {
    container: classNames('!px-[1.5rem] flex justify-between items-center'),
    logo: classNames(
      'block z-100 bg-center h-[85px] bg-no-repeat bg-airstage-logo bg-contain w-[208px]'
    )
  };

  return (
    <>
      <header className="bg-white fixed top-0 left-0 w-full h-auto z-[12]">
        <div
          className={joinClasses([
            desktopClasses.container,
            mobileClasses.container
          ])}
        >
          <h1 id="logo">
            <a
              href="/"
              className={joinClasses([desktopClasses.logo, mobileClasses.logo])}
            >
              <span className="hidden">Fujitsu General</span>
            </a>
          </h1>
          <Menu location={location}></Menu>
        </div>
      </header>
    </>
  );
};

export default Header;
